import {ToadMensagemService} from './../../service/toad-mensagem.service';
import {DiaSemana, ScheduleTipoDiaUtil} from './../../model/constantes';
import {ScheduleExecucao} from './../../model/catalogo';
import {Component, OnInit, Output, EventEmitter, Input, DoCheck} from '@angular/core';
import {JQueryStatic} from 'jquery';

declare var $: JQueryStatic;

@Component({
    selector: 'app-cadastro-schedule-execucao',
    templateUrl: './cadastro-schedule-execucao.component.html',
    styleUrls: ['./cadastro-schedule-execucao.component.css']
})
export class CadastroScheduleExecucaoComponent implements OnInit, DoCheck {

    listaScheduleExecucoes: Array<ScheduleExecucao> = new Array<ScheduleExecucao>();

    scheduleExecucao: ScheduleExecucao = new ScheduleExecucao();

    diaSemanas: DiaSemana[];

    selected: DiaSemana;

    selectedScheduleCodTipoDiaUtil: ScheduleTipoDiaUtil = new ScheduleTipoDiaUtil;

    listaScheduleCodTipoDiaUtil = [];

    chaveComposta: any;

    mensagem: string = '';

    @Output() scheduleExecucaoAdicionada = new EventEmitter();

    @Input() newScheduleExecucao: any;

    constructor(private messageService: ToadMensagemService) {
        // this.formataCalendario = FormataCalendario.getCalendario();
        this.diaSemanas = [
            {codigo: 0, descricao: 'Todos'},
            {codigo: 1, descricao: 'Domingo'},
            {codigo: 2, descricao: 'Segunda'},
            {codigo: 3, descricao: 'Quarta'},
            {codigo: 4, descricao: 'Quinta'},
            {codigo: 5, descricao: 'Sexta'},
            {codigo: 6, descricao: 'Sábado'},

        ];
    }

    ngOnInit() {

        this.listaScheduleCodTipoDiaUtil = [
            {codigo: 1, descricao: 'Dia Útil/Dia Mês Não Ordinal'},
            {codigo: 2, descricao: 'Dia Não Útil/Dia Mês Não Ordinal'},
            {codigo: 3, descricao: 'Dia Útil e Não Útil/Dia Mês Não Ordinal'},
            {codigo: 4, descricao: 'Dia Útil/Dia Mês Ordinal'},
            {codigo: 5, descricao: 'Dia Não Útil/Dia Mês Ordinal'},
            {codigo: 6, descricao: 'Dia Útil e Não Útil/Dia Mês Ordinal'},
        ];
    }

    // Um método de retorno uma chamada que executa a detecção de alterações
    ngDoCheck(): void {

        if (this.newScheduleExecucao != undefined) {
            this.listaScheduleExecucoes = new Array<ScheduleExecucao>();
            this.listaScheduleExecucoes = this.newScheduleExecucao;
            this.scheduleExecucaoAdicionada.emit(this.listaScheduleExecucoes);
        }
    }

    verificaScheduleDia(scl: string) {
        if (scl && scl.length <= 4 && (scl == '*' || /^(?:[1-9]|0[0-9]|1[0-9]|2[0-9]|30|31)$/g.test(scl) || /^[*][/](?:[0-9]|0[0-9]|1[0-9]|2[0-9]|30|31)$/g.test(scl))) {
            return true;
        }
        this.mensagem = '<b style=\'color: #A94442;\'>* Validação do campo \'Dia do mês\' está fora do padrão exigido.</b>\n<br>';

        return false;
    }

    verificaScheduleMes(scl: string) {
        if (scl && scl.length <= 4 && (scl == '*' || /^(?:[1-9]|0[1-9]|10|11|12)$/g.test(scl) || /^[*][/](?:[1-9]|0[1-9]|10|11|12)$/g.test(scl))) {
            return true;
        }
        this.mensagem = '<b style=\'color: #A94442;\'>* Validação do campo \'Mês\' está fora do padrão exigido.</b>\n<br>';
        return false;
    }

    verificaScheduleHora(scl: string) {
        if (scl && scl.length <= 4 && (scl == '*' || /^(?:[0-9]|0[0-9]|1[0-9]|2[0-4])$/g.test(scl) || /^[*][/](?:[0-9]|0[0-9]|1[0-9]|2[0-4])$/g.test(scl))) {
            return true;
        }

        this.mensagem = '<b style=\'color: #A94442;\'>* Validação do campo \'Hora\' está fora do padrão exigido.</b>\n<br>';
        return false;
    }

    verificaScheduleMinuto(scl: string) {
        if (scl && scl.length <= 4 && (scl == '*' || /^(?:[0-9]|0[0-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-9])$/g.test(scl) || /^[*][/](?:[0-9]|0[0-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-9])$/g.test(scl))) {
            return true;
        }

        this.mensagem = '<b style=\'color: #A94442;\'>* Validação do campo \'Minuto\' está fora do padrão exigido.</b>\n<br>';

        return false;
    }

    verificaScheduleDiaSemana(scl: string) {
        if (scl && scl.length <= 4 && (scl == '*' || /^(?:[0-6]|0[0-6])$/g.test(scl) || /^[*][/](?:[0-6]|0[0-6])$/g.test(scl))) {
            return true;
        }

        this.mensagem = '<b style=\'color: #A94442;\'>* Validação do campo \'Dia da semana\' está fora do padrão exigido.</b>\n<br>';

        return false;
    }


    adicionarScheduleExecucao() {

        if (!this.verificaScheduleMinuto(this.scheduleExecucao.minuto)
            || !this.verificaScheduleHora(this.scheduleExecucao.hora)
            || !this.verificaScheduleDia(this.scheduleExecucao.diaDoMes)
            || !this.verificaScheduleMes(this.scheduleExecucao.mes)
            || !this.verificaScheduleDiaSemana(this.scheduleExecucao.diaDaSemana)
        ) {
            $.confirm({
                title: 'Atenção!',
                content: this.mensagem + '<br>Cada campo só pode ser de 1 destes 3 formatos:</br> *</br> NN (numérico entre 1 e 2 digitos)</br> */NN (numérico entre 1 e 2 digitos)',
                type: 'red',
                buttons: {
                    ok: {
                        btnClass: 'btn-blue'
                    }
                },
                onClose: () => {
                    return;
                }
            });
            return;
        }


        // this.scheduleExecucao.diaSemana = this.selected.codigo;

        // this.scheduleExecucao.codTipoDiaUtil = this.selectedScheduleCodTipoDiaUtil.codigo;

        // if (this.scheduleExecucao.ano == 0) {

        //   let dataAtual = new Date();

        //   this.scheduleExecucao.ano = dataAtual.getFullYear();
        // }


        this.listaScheduleExecucoes.push(this.scheduleExecucao);

        this.scheduleExecucao = new ScheduleExecucao();

        this.scheduleExecucaoAdicionada.emit(this.listaScheduleExecucoes);

    }

    // editar a schedule execução
    onRowSelectScheduleExecucao(item) {

        this.scheduleExecucao.segundo = item.segundo;
        this.scheduleExecucao.minuto = item.minuto;
        this.scheduleExecucao.hora = item.hora;
        this.scheduleExecucao.diaDoMes = item.diaDoMes;
        this.scheduleExecucao.mes = item.mes;
        this.scheduleExecucao.diaDaSemana = item.diaDaSemana;

        // this.scheduleExecucao.diaSemana = item.diaSemana;
        // this.scheduleExecucao.diaDoMes = item.diaDoMes;
        // this.scheduleExecucao.ano = item.ano;
        // this.scheduleExecucao.codTipoDiaUtil = item.codTipoDiaUtil;
        // this.scheduleExecucao.horaExecucaoInicial = item.horaExecucaoInicial;
        // this.scheduleExecucao.horaExecucaoFinal = item.horaExecucaoFinal;

        this.removerScheduleExecucao(item);

    }

    removerScheduleExecucao(indice: any) {

        const index = this.listaScheduleExecucoes.indexOf(indice);

        this.listaScheduleExecucoes.splice(index, 1);

    }

}



// WEBPACK FOOTER //
// ./src/app/cadastro-schedule-execucao/cadastro-schedule-execucao.component.ts